import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("ie_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ie_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

const signup = async (name, email, phone, password) => {

  const { data } = await api.post("/auth/signup", {
    name,
    email,
    phone,
    password,
  });

  return data;
};

  const verifyOtp = async (email, otp) => {
    const { data } = await api.post("/auth/verify-otp", { email, otp });
    localStorage.setItem("ie_token", data.token);
    setUser(data.user);
    return data;
  };

  const resendOtp = async (email) => {
    const { data } = await api.post("/auth/resend-otp", { email });
    return data;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ie_token", data.token);
    setUser(data.user);
    return data;
  };


  const loginWithFirebaseToken = async (idToken) => {
    const { data } = await api.post("/auth/firebase-login", {
    id_token: idToken,
    });

    localStorage.setItem("ie_token", data.token);
    setUser(data.user);

    return data;
  };

  const logout = () => {
    localStorage.removeItem("ie_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signup, verifyOtp, resendOtp, login,    loginWithFirebaseToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
